import _ from 'lodash'
import * as THREE from 'three'
import BaseTool from '@glass-designer/tools/baseTool'
import EditingRectangle from '@glass-designer/objects/editingRectangle'
import EditingCircle from '@glass-designer/objects/editingCircle'
import MathsUtils from '@/utils/mathsUtils'
import EditorClipper from '@glass-designer/utils/editorClipper'
import { EditorUserError } from '@glass-designer/utils/editorErrors'

import Config from '@glass-designer/config'
import GlassDesignerTypes from '@glass-designer/types'


// Edge Cutout Tool
// Tool to draw circle / rectangle shapes on a glass edge to create cutouts into the glass shape
// DEPRECATED
export default class EdgeCutoutTool extends BaseTool {
  constructor(editor) {
    super(editor)

    this.type = GlassDesignerTypes.ToolTypes.edgeCutoutTool

    // Setup the editing shape object
    //this.editingShape = new EditingRectangle(this.editor)

    this.editingShape = new EditingCircle(this.editor)
    this.editingShape.setVisible(false)
    this.editingShape.setObjectEventListener(this)
    this.addChildObject(this.editingShape)
  }

  // Tool Active
  // Called when the tool is active
  onToolActive(options = {}) {
    super.onToolActive()

    this.editor.setDimensionsEnabled([GlassDesignerTypes.DimensionTypes.editingLineDimension])
    this.editor.setShapeSelectionEnabled(false)

    // Start the shape creation
    this.resetShapeEditing()

    this.editingShape.setVisible(true)

    this.displayToolSettingsPopover()
  }

  // Tool Inactive
  // Called when the tool is no longer active
  onToolInactive() {
    super.onToolInactive()

    this.editor.resetDimensionsEnabled()
    this.editor.resetSelectionEnabled()

    this.editingShape.setVisible(false)
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

  }

  // Reset the shape creation
  resetShapeEditing() {
    this.editor.component.showToolHelpBox('fa-draw-square', 'Click and drag out the shape')
    //this.editingShape.setVisible(false)

    this.editor.flagRenderRequired()
  }

  // onMouseDownEvent
  onMouseDownEvent(ev, mouseData) {
    super.onMouseDownEvent(ev, mouseData)


    this.editor.flagRenderRequired()
  }

  // onMouseMoveEvent
  onMouseMoveEvent(ev, mouseData) {
    super.onMouseMoveEvent(ev, mouseData)

  }

  // onMouseUpEvent
  onMouseUpEvent(ev, mouseData) {
    super.onMouseUpEvent(ev, mouseData)

    this.editor.flagRenderRequired()
  }

  onMouseWheelEvent(ev, mouseData) {
    super.onMouseWheelEvent(ev, mouseData)
  }

  onTouchStartEvent(ev, touchData) {
    super.onTouchStartEvent(ev, touchData)
  }
  onTouchEndEvent(ev, touchData) {
    super.onTouchEndEvent(ev, touchData)
  }
  onTouchCancelEvent(ev, touchData) {
    super.onTouchCancelEvent(ev, touchData)
  }
  onTouchMoveEvent(ev, touchData) {
    super.onTouchMoveEvent(ev, touchData)
  }


  /**
   * Receive an object event from objects we're listening too
   */
  onReceiveObjectEvent(object, eventType, data) {
    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectMoved) {
      if(object == this.editingShape) {

        
      }
    }

    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectUpdated) {
      if(object == this.editingShape) {

        // Update the frontend UI
        this.displayToolSettingsPopover()
      }
    }
  }


  /**
   * Apply the shape as a boolean operation
   * Either adding & remove the shape from the glass shape
   */
  applyShapeBoolean(addOperation) {

    // Find glass shape closest to the editing shape
    let shape = this.editor.findClosestGlassShape(this.editingShape.position)
    if(shape == null)
      throw new EditorUserError('No glass shape found')

    let subjectSegmentList = shape.segmentList
    let clipSegmentList = this.editingShape.generateSegmentList()

    let clipper = new EditorClipper()
    let clipResult = clipper.performSegmentListClippingOperation(subjectSegmentList, clipSegmentList, addOperation)

    if(clipResult.segmentList.length == 0) {
      throw new EditorUserError('Cutting shape does not intersect glass')
    }


    // TODO: Check make sure the editing shape is along an edge of the shape (not completely inside/outside)



    // TODO: This
    // TODO: Add edge cutout or corner cutout or something like that
    this.editor.startUndoGroup('Cutting shape')
    this.editor.addUndoShape(shape)
    shape.segmentList = clipResult.segmentList

    this.editor.closeCurrentUndoGroup()
    shape.segmentListUpdated()
    shape.updateSceneObject()
    this.editor.onShapeUpdated(shape)

    this.closeTool()
  }


  // Display the tool settings popover for this tool
  displayToolSettingsPopover() {
    var actionButtons = []

    actionButtons = [
      { title: 'Combine Shape', type: 'update', icon: 'fa-plus-circle', tag: 'add' },
      { title: 'Punch Out Shape', type: 'remove', icon: 'fa-minus-circle', tag: 'remove' }
    ]

    // TODO: Adjust for shape type
    this.editor.component.displayShapeToolPopover({
      title: 'Shape Tool',
      actionButtons: actionButtons,
      angle: this.editingShape.angle,
      width: this.editingShape.width,
      height: this.editingShape.height,
      context: this,
      cancelCallback: (ctx, userCancelled) => {
        if(userCancelled)
          ctx.editor.cancelActiveTool()
      },
      applyCallback: (ctx, info) => {
        if(info.actionTag == 'reset') {
          //ctx.resetCuttingLine()
        } else if(info.actionTag == 'add') {
          ctx.applyShapeBoolean(true)
        } else if(info.actionTag == 'remove') {
          ctx.applyShapeBoolean(false)
          
        } else {
          //ctx.applyCutToShape(info.actionTag == 'inside')
        }
      },
      updateCallback: (ctx, info) => {
        ctx.editingShape.angle = info.angle
        ctx.editingShape.width = info.width
        ctx.editingShape.height = info.height
        ctx.editor.render()
      }
    })
  }

}
